export const ROUTE_CONSTANTS_VERSION_0 = {
  LAYOUT: '/v0/',
  LOGIN: '/v0/login',
  Landing: '/landingpage',
  Dashboard: '/:projectId/v0/dashboard',
  Tenants: '/:projectId/v0/tenants',
  ExistingProjects: '/:projectId/v0/projects',
  NewProjects: '/:projectId/v0/newprojects',
  Dataprofiler: '/:projectId/v0/Dataprofiler',
  Dataquality: '/:projectId/v0/Dataquality',
  ExecutionLogs: '/:projectId/v0/Executionlogs',
  Customers: '/:projectId/v0/customers',
  Workflow: '/:projectId/v0/ApprovalWorkflow',
  ExceptionLogs: '/:projectId/v0/exceptionlogs',
  ExceptionLogsDetails: '/:projectId/v0/exceptionlogsdetails',
  wormholeURL : 'http://4.240.55.17:3000',
  MDMURL : 'https://mdm.polestarllp.com/',
  WORMHOLEURL : 'https://wormhole.polestarllp.com/',
  WORKSPACE: '/workspacelist',
  ORCHESTRATOR: '/workspacelist',
  // mdm: '/v0/'
}
